import {useInjex} from '@injex/react-plugin';
import {AlertsManager} from '../managers/alertsManager.mdl';

export default function useAlertsManager(): AlertsManager {
    const [inject] = useInjex();
    return inject<AlertsManager>('alertsManager');
}